<template>
<div class="linecon">
    <div class="line"></div>
    <div class="bartext">{{info}}</div>
    <div class="line"></div>
</div>
</template>

<script>
export default {
    data() {
        return {}
    },
    props: {
        info: String
    }
}
</script>

<style lang="scss" scoped>
.linecon {
    width: 1120px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    margin: 8px auto 20px;
    height: 24px;
    line-height: 24px;

    .bartext {
        font-size: 16px;
        font-weight: 600;
        margin-top: 10px;
        padding: 0 15px;
    }
}

.line {
    position: relative;
    border-bottom: 1px solid #ddd;

    flex: 1;

    span {}
}
</style>
